import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "./api"; 

const useBreadcrumbs = () => {
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    const generateBreadcrumbs = async () => {
      try {
        const { pathname } = location;

        let pathParts = pathname.split("/").filter(Boolean);

       

        // HOME PAGE
        if (pathParts.length === 0) {
          setBreadcrumbs([]);
          return;
        }

        const crumbs = [
          {
            label: "Home",
            link: "/",
          },
        ];

        // ==================================================
        // MAIN MENU
        // URL:
        // /category/main_menu/Workwear
        // ==================================================
        if (
          pathParts[0] === "category" &&
          pathParts[1] === "main_menu"
        ) {
          const mainMenu = decodeURIComponent(pathParts[2]);

          crumbs.push({
            label: mainMenu,
            link: null,
          });

          setBreadcrumbs(crumbs);
          return;
        }

        // ==================================================
        // CATEGORY
        // URL:
        // /category/Category/Tops
        // ==================================================
       
        if (
          pathParts[0] === "category" &&
          pathParts[1] === "Category"
        ) {
          
          const categoryName = decodeURIComponent(pathParts[2]);
 
          const response = await api.get(
            `/api/breadcrumb/category/${encodeURIComponent(
              categoryName
            )}`
          );
          
          const rawData = response?.data || {};
          console.log("CATEGORY RESPONSE", response.data);
          const data = Array.isArray(rawData)
            ? rawData[0]
            : rawData;

          if (data?.main_menu) {
            crumbs.push({
              label: String(data.main_menu),
              link: `/category/main_menu/${encodeURIComponent(
                data.main_menu
              )}`,
            });
          }

          crumbs.push({
            label: String(data?.category || categoryName),
            link: null,
          });

          setBreadcrumbs(crumbs);
          return;
        }

        // ==================================================
        // SUBCATEGORY
        // URL:
        // /category/subcategory/Work Shirts
        // ==================================================
        if (
          pathParts[0] === "category" &&
          pathParts[1] === "subcategory"
        ) {
          const subcategoryName = decodeURIComponent(pathParts[2]);

          const response = await api.get(
            `/api/breadcrumb/subcategory/${encodeURIComponent(
              subcategoryName
            )}`
          );
          console.log("SUBCATEGORY RESPONSE", response.data);
          const rawData = response?.data || {};
          const data = Array.isArray(rawData)
            ? rawData[0]
            : rawData;

          if (data?.main_menu) {
            crumbs.push({
              label: String(data.main_menu),
              link: `/category/main_menu/${encodeURIComponent(
                data.main_menu
              )}`,
            });
          }

          if (data?.category) {
            crumbs.push({
              label: String(data.category),
              link: `/category/Category/${encodeURIComponent(
                data.category
              )}`,
            });
          }

          crumbs.push({
            label: String(data?.subcategory || subcategoryName),
            link: null,
          });

          setBreadcrumbs(crumbs);
          return;
        }
        // ==================================================
        // BRAND PAGE
        // URL:
        // /products/brand/Stormtech
        // ==================================================

        if (
          pathParts[0] === "products" &&
          pathParts[1] === "brand"
        ) {

          const brandName = decodeURIComponent(pathParts[2] || "");

          crumbs.push({
            label: "Brands",
            link: "/brands",
          });

          crumbs.push({
            label: brandName,
            link: null,
          });

          setBreadcrumbs(crumbs);
          return;
        }
        // ==================================================
        // PRODUCT DETAIL PAGE
        // URL:
        // /products/74220/Lite Sneaker OB SR
        // ==================================================

        if (pathParts[0] === "products" && pathParts[1]) {

          const productId = pathParts[1];
          const productName = decodeURIComponent(pathParts[2] || "");

          const response = await api.get(
            `/api/breadcrumb/product/${productId}`
          );

          console.log("PRODUCT RESPONSE", response.data);

          const rawData =
            response?.data?.data || response?.data || {};

          const data = Array.isArray(rawData)
            ? rawData[0]
            : rawData;

          if (data?.main_menu) {
            crumbs.push({
              label: String(data.main_menu),
              link: `/category/main_menu/${encodeURIComponent(
                data.main_menu
              )}`,
            });
          }

          if (data?.category) {
            crumbs.push({
              label: String(data.category),
              link: `/category/Category/${encodeURIComponent(
                data.category
              )}`,
            });
          }

          if (data?.subcategory) {
            crumbs.push({
              label: String(data.subcategory),
              link: `/category/subcategory/${encodeURIComponent(
                data.subcategory
              )}`,
            });
          }

          crumbs.push({
            label: productName,
            link: null,
          });

          setBreadcrumbs(crumbs);
          return;
        }
        // ==================================================
        // SEARCH PAGE
        // URL:
        // /search/test
        // ==================================================

        if (pathParts[0] === "search") {

          const searchTerm = decodeURIComponent(pathParts[1] || "");

          crumbs.push({
            label: searchTerm,
            link: null,
          });

          setBreadcrumbs(crumbs);
          return;
        }
        // ==================================================
        // DEFAULT BREADCRUMBS
        // ==================================================
        const defaultBreadcrumbs = pathParts.map((part, idx) => {
          const url =
            "/" + pathParts.slice(0, idx + 1).join("/");

          const decoded = decodeURIComponent(part);

          const label = decoded
            .replace(/-/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());

          const isLast = idx === pathParts.length - 1;

          return {
            label,
            link: isLast ? null : url,
          };
        });

        setBreadcrumbs([
          {
            label: "Home",
            link: "/",
          },
          ...defaultBreadcrumbs,
        ]);
      } catch (error) {
        console.error("Breadcrumb Error:", error);

        setBreadcrumbs([
          {
            label: "Home",
            link: "/",
          },
        ]);
      }
    };

    generateBreadcrumbs();
  }, [location.pathname]);

  return breadcrumbs;
};

export default useBreadcrumbs;